import React, { useState, useRef, useContext } from 'react';
import { ButtonHeading } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import UnitDetailsTab from 'components/MastersDetailsTabs/UnitDetailsTabs/UnitDetailsTab';
import LoadingBar from 'react-top-loading-bar';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import SupplierSettingsTab from 'components/MastersDetailsTabs/SupplierSettingsTab/SupplierSettingsTab';
import { UserContext } from 'context';

const UnitDetails = () => {
    useDocumentTitle("Unit Details | T360");

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const unitName = queryParams.get('name') || '';
    const { masterData, setMasterDetailsList } = useContext(UserContext);
    const [activeTab, setActiveTab] = useState(1);
    const [detailsData, setDetailsData] = useState({});
    const loadingBarRef = useRef(null); // Create a ref for the loading bar

    const handleDetailsData = (data) => {
        setDetailsData(data);
    };

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: constant.unitDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab
    };

    return (
        <div className=''>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                loaderSpeed={1000}
                shadow={true}
            />
            <ButtonHeading
                title={unitName ? unitName : detailsData?.name}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/unit'); setMasterDetailsList({}) }} // navigate(-1)
            />

            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab === 1 && (
                    <UnitDetailsTab
                        onDataFetch={handleDetailsData}
                        loadingBarRef={loadingBarRef} // Pass the ref to the child component
                    />
                )}
                {activeTab === 2 && <SupplierSettingsTab name='addressBook' />}
            </div>
        </div>
    );
}

export default UnitDetails;
